import type { SpotlightScope } from "@/contexts/feed/domain/spotlight/spotlight-settings"

/**
 * TanStack Query keys for the broker's spotlights. Beside `feedKeys`, NOT inside
 * `feedKeys.all`: a feed invalidation (a heart, a new post) must not refetch the
 * queue, which is fetched once per app load on purpose.
 */
export const spotlightKeys = {
  all: ["feed-spotlight"] as const,
  queue: (surface: SpotlightScope) => ["feed-spotlight", "queue", surface] as const,
  coach: (postId: string) => ["feed-spotlight", "coach", postId] as const,
}
